import { Button, Group, Paper, Stack, Text } from "@mantine/core";
import { IconMoodWrrr } from "@tabler/icons-react";

function ErrorFallback() {
  return (
    <Paper withBorder m="md" p="md">
      <Stack>
        <Group mt="md">
          <IconMoodWrrr size={50} />
          <Text fz="xl">Sorry, an error occurred!</Text>
        </Group>
        <Text mt="lg">Something went wrong. Our team has been notified.</Text>
        <Button variant="default" onClick={() => window.location.reload()}>
          Reload Page
        </Button>
      </Stack>
    </Paper>
  );
}

export default ErrorFallback;
